"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseLog = void 0;
var hosts_1 = require("../utils/hosts");
var constant_1 = require("../constant");
var utils_1 = require("../utils/utils");
var SLS_ERROR = '上报SLS错误';
var slsOptions = {
    sit: {
        host: 'www.test.mistong.com/web-log',
        logstore: constant_1.logStore,
    },
    pre: {
        host: 'www.ewt360.com/web-log',
        logstore: constant_1.logStore,
    },
    prod: {
        host: 'www.ewt360.com/web-log',
        logstore: constant_1.logStore,
    },
};
function getEnv() {
    if (hosts_1.hostInfo.isTest || hosts_1.hostInfo.isLocal) {
        return 'sit';
    }
    if (hosts_1.hostInfo.isPre) {
        return 'pre';
    }
    return 'prod';
}
function baseLog(result) {
    result = result || {};
    var _a = slsOptions[getEnv()], host = _a.host, logstore = _a.logstore;
    function send(item) {
        var url = "//".concat(host, "/logstores/").concat(logstore, "/track?APIVersion=0.6.0");
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status !== 200) {
                    console.error(SLS_ERROR);
                }
            }
        };
        xhr.onerror = function () {
            console.error(SLS_ERROR);
        };
        xhr.onabort = function () {
            console.error(SLS_ERROR);
        };
        var body;
        body = (0, utils_1.safeJSONStringify)(item);
        xhr.send(body);
    }
    result.__logs__ = result.__logs__.map(function (item) {
        return __assign({}, item);
    });
    var logContent = __assign({}, result);
    send(logContent);
}
exports.baseLog = baseLog;
